import React from 'react'
import { Link } from 'gatsby'
import { Laboratorio } from '@labcon/copesa-logos'
import logoPhilips from '@/images/logo-philips.svg'

const Header = () => {
  return (
    <div className="fixed top-0 z-20 w-full sm:h-20 h-14 bg-white">
      <div className="container grid items-center grid-cols-12 gap-2 p-2 mx-auto sm:h-20 h-14 sm:p-4">
        <h1 className="col-span-3">
          <a
            href="https://www.laboratoriodecontenidos.cl/?utm_source=triviaPhilips&utm_medium=especiales&"
            target="_blank"
            rel="noopener noreferrer">
            <Laboratorio className="h-8" />
          </a>
        </h1>
        <div className="flex items-center justify-end col-span-9 text-center sm:justify-center sm:col-span-6">
          <span className="inline-block pr-2 text-xs leading-none">
            Presentado por:{' '}
          </span>
          <img className="h-4 sm:h-6" src={logoPhilips} alt="Philips" />
        </div>
        <div className="justify-end hidden col-span-3 sm:flex"></div>
      </div>
    </div>
  )
}

export default Header
